// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen5_comp__5lkd2"};